import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * 
 * Optimized for fresh data on navigation:
 * - staleTime: 0 - Always consider data stale, refetch on mount
 * - gcTime: 5 minutes - Keep in cache for back button (but refetch on forward nav)
 * - Auto-retry failed queries 3 times with exponential backoff
 * - Refetch on window focus for latest data
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Always fetch fresh data on mount (important for forward navigation)
      gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes for back button
      retry: 3, // Retry failed requests 3 times
      refetchOnWindowFocus: true, // Refetch when user returns to tab
      refetchOnReconnect: true, // Refetch when internet reconnects
      refetchOnMount: true, // Always refetch when component mounts (default, but explicit)
    },
  },
});
